import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Table, Badge, Button } from 'reactstrap'
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import {
  FaBars
} from 'react-icons/lib/fa'
import styles from './PagesDrillDownTable.scss'

// Sortable page table components

const DragHandle = SortableHandle(() => <span className={styles.dragHandle} title='Reorder'><FaBars />&nbsp;</span>)
// When running tests, return regular tr and tbody
const SortableRow = process.env.NODE_ENV === 'test' ? ({children}) => <tr>{children}</tr> : SortableElement(({children}) => <tr>{children}</tr>) // eslint-disable-line
const SortableTableBody = process.env.NODE_ENV === 'test' ? ({children}) => <tbody>{children}</tbody> : SortableContainer(({children}) => <tbody>{children}</tbody>) // eslint-disable-line
const hasChildren = row => row.subpages && row.subpages.length
const bindDrillDown = (row, that, onDrillDown) => {
  let attributes = {}
  if (hasChildren(row)) {
    attributes = {
      className: styles.link,
      onClick: onDrillDown.bind(that, row.id)
    }
  }
  return attributes
}

const PagesDrillDownTable = (props) => (
  <Table className='mt-2'>
    <thead>
      <tr>
        <th>Title</th>
        <th>Path</th>
        <th>Children</th>
        <th>Updated Date</th>
        <th>Updated By</th>
      </tr>
    </thead>
    <SortableTableBody onSortEnd={props.onPageSort} useDragHandle>
      {props.pages.map((row, i) =>
        <SortableRow key={i} index={i}>
          <td>
            {props.onPageSort && <DragHandle />}
            <a {...bindDrillDown(row, props.this, props.onDrillDown)}>
              {row.title}
              {row.draftId && <Badge className='ml-1' title='Draft'>D</Badge>}
              {row.publishedId && <Badge className='ml-1' color='primary' title='Published'>P</Badge> }
            </a>
          </td>
          <td>{row.path}</td>
          <td {...bindDrillDown(row, props.this, props.onDrillDown)}>{row.subpages ? row.subpages.length : 0}</td>
          <td>{moment(row.updatedAt).fromNow()}</td>
          <td>{`${(row.updatedBy.firstName || row.updatedBy.lastName) ? row.updatedBy.firstName + ' ' + row.updatedBy.lastName : row.updatedBy.email}`}</td>
          <td>
            { props.currentPageId !== row.id
              ? <Button onClick={() => props.onSelect.bind(props.this, row)()}>Use</Button>
              : 'Can\'t link to self'
            }
          </td>
        </SortableRow>
      )}
    </SortableTableBody>
  </Table>
)

PagesDrillDownTable.propTypes = {
  currentPageId: PropTypes.number,
  pages: PropTypes.array,
  onPageSort: PropTypes.func,
  this: PropTypes.object, // eslint-disable-line
  onDrillDown: PropTypes.func.isRequired, // eslint-disable-line
  onSelect: PropTypes.func.isRequired // eslint-disable-line
}

export default PagesDrillDownTable



// WEBPACK FOOTER //
// ./src/components/PagesDrillDownTable/PagesDrillDownTable.js